import {
  useConvertParkingLotFullSession,
  useSessionTree,
} from '@services/session'
import { momentToString } from '@shared/innmaxLib/utils/webHelper'
import { cond } from 'ramda'
import { useCallback } from 'react'

export const useConvertOtaRecord = () => {
  const { byId } = useSessionTree()

  const convert = useConvertParkingLotFullSession()

  const converter = useCallback(
    (data: any) => {
      return data
        ? {
            ...data,
            createAtStr: data.createAt ? momentToString(data.createAt) : '',
            ...convert(data?.deviceList?.[0], 'sessionId'),
            statusStr: cond([
              [(status: number) => status === -1, () => '更新異常'],
              [(status: number) => status === 0, () => '更新中'],
              [(status: number) => status === 1, () => '已完成'],
            ])(data?.status),
            statusColor: cond([
              [(status: number) => status === -1, () => '#E17567'],
              [(status: number) => status === 0, () => '#FFCC2B'],
              [(status: number) => status === 1, () => '#fff'],
            ])(data?.status),
          }
        : null
    },
    [byId]
  )

  return {
    converter,
  }
}

export const useConvertOtaFile = () => {
  const converter = useCallback((data: any) => {
    return data
      ? {
          ...data,
          createAtStr: data.createAt ? momentToString(data.createAt) : '',
        }
      : null
  }, [])

  return {
    converter,
  }
}
